import { Box, Typography } from "@material-ui/core";
import { FC, MutableRefObject, useCallback, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useCurrentUser from "../../../hooks/useCurrentUser";

import { roomMessagesSubCollRef } from "../../../utils/referencies";
import { applyCreateTimestamp } from "../../../utils/timestamp";
import ChatAction from "../components/ChatAction";
import { BaseChatContext } from "../index";
import { IAttachment, IChatParams } from "../type";
import { brandStatus } from "../utils";

const ChatActionContainer: FC<ChatInputProps> = ({ scrollRef }) => {
  const [ref, setRef] = useState<MutableRefObject<any>>({ current: null });
  const { roomId } = useParams<IChatParams>();
  const { user } = useCurrentUser();

  const { senderRef } = useContext(BaseChatContext);

  useEffect(() => {
    if (scrollRef) {
      setRef(scrollRef);
    }
  }, [scrollRef]);

  const handleSendMessage = useCallback(
    async (text: string | null = null, attachment: IAttachment | null = null) => {
      const trimmedMessage = text ? text.trim() : null;

      const message = applyCreateTimestamp({
        text: trimmedMessage,
        attachment,
        senderRef,
      });

      console.log({ message });
      console.log(roomMessagesSubCollRef(roomId));

      if ((trimmedMessage && trimmedMessage.length > 0) || attachment)
        try {
          await roomMessagesSubCollRef(roomId).doc().set(message);
          if (ref.current) {
            ref.current.scrollTo({ top: ref.current.scrollHeight, behavior: "smooth" });
          }
        } catch (ex: any) {
          console.log(ex.message);
        }
    },
    [ref]
  );

  return (
    <>
      {user.status !== brandStatus.semiDisabled ? (
        <ChatAction onSend={handleSendMessage} placeholder="Write a message..." sendAttachment />
      ) : (
        <Box height="100%" display="flex" justifyContent="center" alignItems="center">
          <Typography color="textSecondary" variant="body2">
            This brand is semi disabled, you can't chat
          </Typography>
        </Box>
      )}
    </>
  );
};

interface ChatInputProps {
  participants: string[];
  scrollRef: MutableRefObject<any>;
}

export default ChatActionContainer;
